import React from "react"
import { Link } from "gatsby"
import Footer2 from "../components/footer2"

const Layout = props => {
  const { title, children } = props
  const [toggleNav, setToggleNav] = React.useState(false)
  return (
    <div className={`site-wrapper ${toggleNav ? `site-head-open` : ``}`}>
      <header className="site-head">
        <div className="site-head-container">
          <a
            className="nav-burger"
            href={`#`}
            onClick={() => setToggleNav(!toggleNav)}
          >
            <div className="hamburger hamburger--collapse">
              <div className="hamburger-box">
                <div className="hamburger-inner" />
              </div>
            </div>
          </a>
          <nav id="swup" class="site-head-left">
            <ul className="nav" role="menu">
              {/* <li className="nav-home nav-current" role="menuitem">
                <Link to={`/`}>Home</Link>
              </li> */}
              <li className="nav-about" role="menuitem">
                <Link to={`/about`}>About</Link>
              </li>
              <li className="nav-tags" role="menuitem">
                <Link to={`/teachers`}>Our Staff</Link>
              </li>
              <li className="nav-tags" role="menuitem">
                <Link to={`/tags/studio-info`}>Studio Info</Link>
              </li>
              <li className="nav-photovogue" role="menuitem">
                <Link to={`/class-schedule`}>Schedule</Link>
              </li>
              <li className="nav-tags" role="menuitem">
                <Link to={`/tags/blog`}>Latest News</Link>
              </li>
              <li className="nav-tags" role="menuitem">
                <Link to={`/tuition`}>Tuition</Link>
              </li>
            </ul>
          </nav>
          <div className="site-head-center">
            <Link className="site-head-logo" to={`/`}>
              {title}
            </Link>
          </div>
          <div className="site-head-right">
            <div className="social-links">
              <a
                href="https://app.jackrabbitclass.com/jr3.0/ParentPortal/Login?orgId=515790"
                title="Parent-Portal"
                target="_blank"
                rel="noopener noreferrer"
              >
                Parent Portal
              </a>
              <a
                href="https://gcda2020.netlify.com/class-schedule"
                title="Class-Registration"
                target="_self"
                rel="noopener noreferrer"
              >
                Class Registration
              </a>
            </div>
          </div>
        </div>
      </header>
      <main id="site-main" className="site-main">
        <div id="swep" className="transition-fade">
          {children}
        </div>
      </main>
      <Footer2 />
      <footer className="site-foot">
        &copy; {new Date().getFullYear()} <Link to={`/`}>{title}</Link> &mdash;
        Website developed by{" "}
        <a
          href="https://alexcovo.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          Alex Covo Studio NYC
        </a>
      </footer>
    </div>
  )
}

export default Layout
